import React, { useEffect, useState } from 'react';
import { Button, Icon, Pdf, Text } from '../../Atoms';
import docIcon from '../../assets/icons/doc.svg';
import { blue } from '../../Config/Config';
import {
  apiGetAllCategories,
  apiGetDocumentsById,
  apiGetGaranties,
  apiGetSpVieDocument
} from '../../Api/Documents/Documents';

export const createBlob = async (data) => {
  try {
    const blob = await (
      await fetch(`data:application/pdf;base64,${data}`)
    ).blob();
    const url = URL.createObjectURL(blob);
    return { blob, url };
  } catch (err) {}
};
const DocList = ({ contract, isGarantie }) => {
  const [docSelectedUrl, setDocSelectedUrl] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [garanties, setGaranties] = useState([]);

  useEffect(() => {
    if (isGarantie) {
      const getGaranties = async () => {
        const res = await apiGetGaranties(contract?.contractNumber);
        console.log(res);
        if (res.status == 200) {
          setGaranties(res.data);
        } else {
          setErrorMessage(res?.errors[0]);
        }
      };
      getGaranties();
    }
  }, [isGarantie]);

  const documents = isGarantie
    ? garanties
    : contract?.attachments?.filter(
        (el) => !el.name?.toLowerCase().includes('garanties')
      ) || [];

  const fetchDocument = async (id) => {
    const res = await apiGetSpVieDocument(id);
    return res;
  };

  const blobify = async (content, download = false) => {
    const { url } = await createBlob(content);
    if (url) {
      if (download) {
        const download = document.createElement('a');
        download.setAttribute('href', url);
        download.setAttribute('target', '_blank');
        download.click();
      } else {
        setDocSelectedUrl(url);
      }
    }
  };
  const onOpenOrDownload = async (id, download = false) => {
    if (isGarantie) {
      blobify(garanties[0]?.content, download);
    } else {
      const res = await fetchDocument(id);
      if (res.status === 200) {
        blobify(res.base64pdf, download);
      }
    }
  };
  return (
    <div style={{ marginBottom: 100 }}>
      {docSelectedUrl ? (
        <div className="content-template-document-sended">
          <div className="container-doc-sended-step2"></div>
          <Pdf url={docSelectedUrl} />
          <div
            className="container-btn-downlond-doc"
            style={{ paddingBottom: '50px' }}
          >
            <Button
              text="Retour"
              onClick={() => setDocSelectedUrl('')}
              className="btn-downlond-doc"
            />
          </div>
        </div>
      ) : (
        <>
          {documents?.map((doc) => (
            <DocItem
              key={doc.id}
              onDownLoad={(id) => onOpenOrDownload(id, true)}
              onOpen={(id) => onOpenOrDownload(id)}
              doc={doc}
              setDocSelectedUrl={setDocSelectedUrl}
            />
          ))}

          <div style={{ marginTop: 50, width: '50%' }}>
            <Text className="contract-benef-name" text={errorMessage} />
          </div>
        </>
      )}
    </div>
  );
};

const DocItem = ({ doc, onOpen, onDownLoad }) => {
  return (
    <div className="contract-item-container">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 10
        }}
      >
        <div>
          <img src={docIcon} />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 5
          }}
        >
          <Text className="contract-title" text={doc?.name} />
        </div>
      </div>

      <div className="container-icon-document-seneded">
        <Icon
          icon="Eyes"
          size="17px"
          className="cursor"
          onClick={() => onOpen(doc?.id)}
        />
        <Icon
          icon="Telechargement"
          size="17px"
          color={blue}
          className="cursor"
          onClick={() => onDownLoad(doc?.id)}
        />
      </div>
    </div>
  );
};

export default DocList;
